import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { useTargets } from "./TargetsContext";
import {
  currentDateTime,
  formatRoundTime,
  formatRoundDate,
} from "../../../utils/dateUtils.js";
import Filter from "../../../components/Filter/Filter.js";
import TargetsTable from "./TargetsTable.js";
import { MESSAGES } from "../../../utils/messages.js";

const DistanceTable = () => {
  const { distanceParam } = useParams();
  const distance = distanceParam.replace("distance", "");
  const { timeSlots, loading, error, fetchRounds } = useTargets();
  const [filteredTimeSlots, setFilteredTimeSlots] = useState([]);

  useEffect(() => {
    const current = currentDateTime();
    setFilteredTimeSlots([]);
    fetchRounds(current, distance);
  }, [fetchRounds, distance]);

  useEffect(() => {
    timeSlots.forEach((slot) => {

      slot?.rounds.forEach((round) => {
      let shootingMap = {};
        round?.players.forEach((player) => {
          shootingMap[[player["target"]]] =
            (shootingMap[[player["target"]]] ?? 0) + 1;
          player.position = shootingMap[[player["target"]]];
        });
      });
    });

    console.log(timeSlots);

    setFilteredTimeSlots(timeSlots);

  }, [timeSlots]);

  const handleSearch = (filters) => {
    let filtered = timeSlots.map((timeSlot) => {
      let filteredRounds = timeSlot.rounds.map((group) => {
        let filteredPlayers = [...group.players];

        if (filters.country) {
          filteredPlayers = filteredPlayers.filter(
            (p) => p.country === filters.country
          );
        }

        if (filters.playerName) {
          filteredPlayers = filteredPlayers.filter((p) =>
            p.name.toLowerCase().includes(filters.playerName.toLowerCase())
          );
        }

        return {
          ...group,
          players: filteredPlayers,
        };
      });

      return {
        ...timeSlot,
        rounds: filteredRounds,
      };
    });

    setFilteredTimeSlots(filtered);
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

  if (!timeSlots || timeSlots.length === 0) {
    return <div>{MESSAGES.NO_DATA}</div>;
  }

  return (
    <>
      <Filter onSearch={handleSearch} />
      {filteredTimeSlots.map((timeSlot, index) => {
        const time = formatRoundTime(timeSlot.round_schedule?.round_time);
        const date = formatRoundDate(timeSlot.round_schedule?.round_time);

        return (
          <div key={index} className="time-slot-section">
            <TargetsTable
              event={distance}
              date={date}
              time={time}
              data={timeSlot.rounds}
            />
          </div>
        );
      })}
    </>
  );
};

export default DistanceTable;
